import { Button } from '@factorialco/deprecated-design-system'
import { CompetencyLevelFragment } from 'generated/resources/graphql'
import { CompetenciesCompetencyLevelEditModalDocument } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useForm } from 'modules/core/hooks/useForm'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import {
  LevelData,
  LevelForm,
  validateLevel,
} from 'modules/competencies/components/CompetencyLevelForm'

interface Props {
  level: CompetencyLevelFragment
  onClose: () => void
  onSuccess: () => void
}

export const CompetencyLevelEditModal = ({ level, onClose, onSuccess }: Props) => {
  const [update] = useMutation(CompetenciesCompetencyLevelEditModalDocument, {
    extractorFn: (data) => data.competenciesMutations.updateBasicInfoCompetenciesCompetencyLevel,
  })

  const form = useForm<LevelData>({
    defaultValues: {
      id: String(level.id),
      name: level.name,
      description: level.description,
      position: level.position + 1,
    },
    validate: (data) => {
      const { errors, hasError } = validateLevel(data)
      if (hasError) {
        return errors
      }

      return
    },
    onSubmit: async (data) => {
      const result = await update({
        variables: {
          id: String(level.id),
          name: data.name,
          description: data.description,
        },
      })

      const handled = handleResult(result, (errors) => {
        if (Object.keys(errors).length > 0) {
          form.setErrors(errors)
        }
      })

      if (handled.success) {
        app.setFlash({
          type: 'correct',
          message: i18n.t('common.saved_successfully'),
        })

        onSuccess()
      }

      return handled
    },
  })

  return (
    <Modal
      title={i18n.t('competencies_v3.levels.edit.title')}
      illustration="add-first"
      onClose={onClose}
      onSubmit={() => {
        form.handleSubmit()
      }}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button submit loading={form.isSubmitting}>
            {i18n.t('common.save')}
          </Button>
        </>
      }
    >
      <LevelForm
        level={form.values}
        errors={form.errors}
        touched={form.touched}
        onChange={(value) => form.setValues(value)}
        onBlur={(fieldKey) => {
          form.setFieldTouched(fieldKey, true)
        }}
      />
    </Modal>
  )
}
